import { agentsColumns, tableViewNames } from '../../../../agent-production/constants/agentProductionConstants';
import { colSettings } from '../agGrid/colSettings';

const addedOfficesColumns = {
  [tableViewNames.addedOffices]: {
    id: tableViewNames.addedOffices,
    sortable: false,
    showPagination: false,
    tables: [
      {
        col: agentsColumns.isSelected, sortable: false,
        colDef: { ...colSettings.checkboxMedium, headerCheckboxSelection: true, checkboxSelection: true, },
      },
      { col: agentsColumns.officeName, colDef: colSettings.textSm },
      { col: agentsColumns.officeId, colDef: colSettings.textSmRightAlign },
      { col: agentsColumns.city, colDef: colSettings.textSm },
    ]
  }
};

export default addedOfficesColumns;
